import {
  AssetLogo,
  isSvgIconName,
  SvgIconNames,
  Toggle,
} from '@toggle/design-system';
import React from 'react';

import { ChartEntity } from '~/types/chart-entity.types';
import { getChartEntityLogoDisplay } from '~/utils/entity/chart-entity';

import * as S from './ChartTypeSelectorItem.style';

export interface ChartTypeSelectorItemProps {
  entity: ChartEntity;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ChartTypeSelectorItem = ({
  entity,
  isChecked,
  onClick,
  disabled = false,
}: ChartTypeSelectorItemProps) => {
  const logoDisplay = getChartEntityLogoDisplay(entity);
  const safeIconName: SvgIconNames = isSvgIconName(logoDisplay.iconName)
    ? logoDisplay.iconName
    : 'ChartLine';
  const safeSubClassIcon: SvgIconNames = isSvgIconName(logoDisplay.subClassIcon)
    ? logoDisplay.subClassIcon
    : 'ChartLine';

  return (
    <S.Wrapper>
      <S.AssetWrapper>
        <AssetLogo
          type={logoDisplay.variant}
          isNotStockEntity={logoDisplay.isNotStockEntity}
          isFiEntity={logoDisplay.isFiEntity}
          placeholderIconName={safeIconName}
          placeholderSubClassIcon={safeSubClassIcon}
          entity={{
            class: entity.class,
            tag: entity.tag,
            name_short: entity.name_short,
          }}
          size={20}
          logoUrl={entity.logo_urls.light_png}
        />
        <S.AssetTicker>{entity.formattedTicker}</S.AssetTicker>
      </S.AssetWrapper>
      <Toggle
        data-testid={`${entity.formattedTicker}toggle`}
        isChecked={isChecked}
        onClick={onClick}
        disabled={disabled}
      />
    </S.Wrapper>
  );
};
